import React from 'react';
import Modal from '../Modal';

const PopupLocation = (props) => {
	const { isOpen = false, onClose } = props;
	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<div className={`bg-white px-4 py-8 rounded-xl shadow-custom flex flex-col justify-center items-center text-center gap-4`}>
				<div className='text-gray-900 text-sm font-semibold'>Maaf anda tidak bisa kembali ke halaman beranda.</div>
				<div className='text-gray-700 text-xs font-normal'>atur alamat atau lokasi mu terlebih dahulu untuk melihat restoran yang anda cari</div>
				<button onClick={onClose} className='w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3 items-center border-0' id='popup_location_confirm'>
					Atur Lokasi mu
				</button>
			</div>
		</Modal>
	);
};

export default PopupLocation;
